/* Unpublished theme only. Load before native/app scripts; reject storefront writes. */
(() => {
  'use strict';
  // Checkout has to write the bag into the Shopify cart. Those cart calls are allowed.
  const isCartWrite = url => {
    try { return /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(new URL(url, location.href).pathname); }
    catch (_) { return false; }
  };
  const isMutation = (url, method='GET') => {
    try {
      const u = new URL(url, location.href);
      if (u.origin !== location.origin || isCartWrite(u.href)) return false;
      return !['GET','HEAD','OPTIONS'].includes(String(method).toUpperCase()) || /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:checkout|checkouts)(\/|$)/.test(u.pathname);
    } catch (_) { return false; }
  };
  const blocked = () => new Error('THEIAN unpublished preview: storefront writes are disabled.');
  const nativeFetch = window.fetch;
  window.fetch = function(input, init) {
    const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    if (isMutation(url, init?.method || input?.method || 'GET')) return Promise.reject(blocked());
    return nativeFetch.apply(this, arguments);
  };
  const xhrOpen=XMLHttpRequest.prototype.open, xhrSend=XMLHttpRequest.prototype.send;
  const pending = new WeakMap();
  XMLHttpRequest.prototype.open=function(method,url) { pending.set(this,isMutation(url,method)); return xhrOpen.apply(this,arguments); };
  XMLHttpRequest.prototype.send=function() { if(pending.get(this)) throw blocked(); return xhrSend.apply(this,arguments); };
  const beacon = navigator.sendBeacon?.bind(navigator);
  if(beacon) navigator.sendBeacon=(url,data) => isMutation(url,'POST') ? false : beacon(url,data);
  const tell = (kind, target) => document.dispatchEvent(new CustomEvent('th-native-preview', {detail:{kind,target}}));
  const cartPath = url => { try { return /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:cart|checkout|checkouts)(\/|\.|$)/.test(new URL(url,location.href).pathname); } catch (_) { return false; } };
  document.addEventListener('click', event => {
    const target=event.target.closest('a,button,input[type="submit"],.js-grid-cart,.js-drawer-open-right');
    if(!target || target.closest('.th-scope'))return;
    const purchase=target.matches('.js-grid-cart,[name="add"],[name="checkout"],.product-form__cart-submit,.add-to-cart') || target.closest('.shopify-payment-button');
    const form=target.closest('form');
    const submit=target.matches('button[type="submit"],input[type="submit"]') && form && form.method.toLowerCase()!=='get';
    if(purchase || submit || target.matches('.js-drawer-open-right') || (target.tagName==='A' && cartPath(target.href))) {
      event.preventDefault();event.stopImmediatePropagation();
      if(event.isTrusted)tell(purchase||submit?'purchase':'bag',target);
    }
  },true);
  document.addEventListener('submit',event=>{
    if(event.target.closest('.th-scope') || event.target.method.toLowerCase()==='get') return;
    event.preventDefault();event.stopImmediatePropagation();if(event.isTrusted)tell('purchase',event.target);
  },true);
  const submit=HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit=function(){
    if(this.method.toLowerCase()!=='get')return;
    return submit.apply(this,arguments);
  };
})();
